import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { ReactComponent as UploadInvoicesIconImage } from './upload-invoices-icon.svg';

const UploadInvoicesIcon = ({ sx, className }) => (
  <Box
    className={className}
    sx={{
      display: 'inline-flex',
      flexShrink: 0,
      width: 190,
      height: 119,
      ...sx,
    }}
  >
    <UploadInvoicesIconImage style={{ width: '100%', height: '100%', display: 'block' }} />
  </Box>
);

UploadInvoicesIcon.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.string,
};

UploadInvoicesIcon.defaultProps = {
  sx: undefined,
  className: undefined,
};

export default UploadInvoicesIcon;
